import steps from '~/languages/en/help/pickup/steps.js';
import additional from '~/languages/en/help/pickup/additional.js';

export default {
  title: {
    base: 'Collecting your prescription in-person from your',
    keyword: 'local pharmacy',
  },
  steps,
  additional,
};
